<template>
	<div class="h-100">
		<sf-data-table
			ref="table"
			:columns="columns"
			:rows="rows"
			selection
			:excel="isButton_(scrId, 'EX')"
			v-bind="masterPagingInfo"
			rowKey="prvsClCd"
			:pageUnit="masterPagingInfo.pageUnit"
			:pageArray="screen.pageArray"
			:totalSize="masterPagingInfo.totalSize"
			@row-dblclick="dblClickRow"
		>
			<!--컬럼에 아이콘 등록방법 시작 -->
			<template v-slot:customRows="slotProps">
				<!--Lts -->
				<template v-if="slotProps.column.property === 'spcRslt'">
					<div class="position-relative h-100">
						<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)"></el-input>
					</div>
				</template>
			</template>
			<!--컬럼에 아이콘 등록방법 끝 -->

			<template v-slot:actionsLeft>
				<!-- 추가 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{
					getButtonMsg_(scrId, 'AD')
				}}</sf-button>
				<!-- 저장 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveAction">{{
					getMessage_('MWCC000138')
				}}</sf-button>
				<!-- 항목복사 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="copyPopup">{{
					getMessage_('QWCC001098')
				}}</sf-button>
				<!-- 삭제 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">{{
					getMessage_('QWCC001136')
				}}</sf-button>
				<!-- 엑셀템플릿 다운 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'EU')" icon="square-plue" :onClick="downExcelTemp">{{
					getMessage_('QWCC001799')
				}}</sf-button>
				<!-- 엑셀업로드 -->
				<sf-button line size="sm" v-if="isButton_(scrId, 'EU')" icon="square-plue" :onClick="openModal">{{
					getMessage_('QWCC000927')
				}}</sf-button>
				<!-- 항목복사 -->
				<!-- <sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button> -->
			</template>
		</sf-data-table>
		<!-- 팝업창 영역 시작-->
		<part-cku-prvs-popup ref="partCkuPrvsPopup" :scrId="scrId" />
		<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="excelRefresh" />
		<!-- 팝업창 영역 끝-->
	</div>
</template>

<script>
import PartCkuPrvsPopup from '@qms/pqy/pcku/PartCkuPrvs/Content/Popup/PartCkuPrvsPopup.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
import * as yup from 'yup';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import qmsUtils from '@/qmsUtils';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		await this.getCommCodes_({ key: 'ckuPrvsList', codeType: 'CKU_PRVS' }); //검사항목;
		await this.getCommCodes_({ key: 'ckuWayList', codeType: 'CKU_WAY' }); //검사방법;
		await this.getCommCodes_({ key: 'utmList', codeType: 'UTM' }); //단위;
		await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' }); //사용여부;
		await this.getCommCodeDetails_({ key: 'ckuWayList2', codeType: 'CKU_WAY' }); //검사방법2;
	},
	components: {
		PartCkuPrvsPopup,
		ExcelUploadModal
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.masterList;
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '60px' },
				// { label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' },
				{
					//사용여부
					label: this.getMessage_('MWCC000145'),
					prop: 'useYnNm',
					width: '100px',
					form: {
						type: 'select',
						options: this.getUseYnList_
					}
				},
				{
					// 검사항목
					label: this.getMessage_('QWCC001058'),
					prop: 'ckuPrvsCdNm',
					width: '120px',
					form: {
						type: 'select',
						options: this.getCkuPrvsList_,
						isDisabled: this.isAdded
					}
				},
				{
					// 항목분류
					label: this.getMessage_('QWCC001059'),
					prop: 'prvsClCd',
					width: '100px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isDisabled
					}
				},
				{
					// 항목분류명
					label: this.getMessage_('QWCC001060'),
					prop: 'prvsClNm',
					width: '130px',
					form: {
						type: 'input',
						maxLength: 50,
						isDisabled: this.isAdded
					}
				},
				{
					// 검사방법
					label: this.getMessage_('QWCC001062'),
					prop: 'ckuWayCdNm',
					width: '80px',
					form: {
						type: 'select',
						options: this.getCkuWayList_,
						isDisabled: this.isAdded
					}
				},
				{
					// 규격하한
					label: this.getMessage_('QWCC001204'),
					prop: 'nrmLlmtVal',
					width: '80px',
					form: {
						maxLength: 9,
						type: 'number'
					}
				},
				{
					// 규격상한
					label: this.getMessage_('QWCC001205'),
					prop: 'nrmUplmVal',
					width: '80px',
					form: {
						maxLength: 5,
						type: 'number'
					}
				},
				{
					// 스펙
					label: this.getMessage_('QWCC001884'),
					prop: 'spcRslt',
					width: '130px',
					custom: true
				},
				{
					// 단위
					label: this.getMessage_('RCMS000090'),
					prop: 'utmCd',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUtmList_
					}
				},
				{
					// 정렬
					label: this.getMessage_('MWPP000137'),
					prop: 'sort',
					width: '60px',
					form: {
						type: 'input',
						maxLength: 20
					}
				}
			];
		},
		schema() {
			return yup.object().shape({
				ckuPrvsCdNm: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001058')])), //{0}은(는) 필수 입력 값 입니다. , 검사항목
				prvsClNm: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001060')])) // 은 필수 입력 항목입니다. , 항목분류명
					.max(50, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('QWCC001060'), 50])), // {0}은 최대 {1} 자리까지 입력 가능합니다., 항목분류명
				ckuWayCdNm: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001062')])) //{0}은(는) 필수 입력 값 입니다. , 검사방법
				//utmCd: yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('RCMS000090')])) //{0}은(는) 필수 입력 값 입니다. , 단위
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		isAdded({ row }) {
			if (row.prvsClCd == null || row.prvsClCd == '') return false;
			else return true;
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		addRow() {
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addMasterRow_().then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		makeValidate(row) {
			const ckuWayListDesc = this.getCkuWayList2_;
			let chkYn = false;

			for (let i = 0; i < ckuWayListDesc.length; i++) {
				let descRow = ckuWayListDesc[i];
				if (row.ckuWayCd === descRow.commCd) {
					let cdDesc2 = descRow.cdDesc + '';
					if (cdDesc2 === 'Y') {
					} else {
						//min, max, 규격상, 규격하 필수체크
						chkYn = true;
						break;
					}
				}
			}

			if (chkYn) {
				if (row.nrmLlmtVal === null || row.nrmLlmtVal === '') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001204')])); // 은 필수 입력 항목입니다. 규격하한
				}

				if (row.nrmUplmVal === null || row.nrmUplmVal === '') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001205')])); // 은 필수 입력 항목입니다. 규격상한
				}

				var nrmUplmVal = parseFloat(row.nrmUplmVal);
				var nrmLlmtVal = parseFloat(row.nrmLlmtVal);
				if (nrmUplmVal === nrmLlmtVal || nrmLlmtVal > nrmUplmVal) {
					throw new TypeError(
						this.$sf_formatString(this.getMessage_('QWCC001208'), [this.getMessage_('QWCC001204'), this.getMessage_('QWCC001205')])
					); // {0}은 {1}보다 작거나 같을 수 없습니다. 규격상한, 규격하한
				}
			}
		},
		saveAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selected = this.$refs.table.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				for (let i = 0; i < selected.length; i++) {
					this.schema.validateSync(selected[i]);
					this.makeValidate(selected[i]);
				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.save }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);
			try {
				const saveRows = this.$refs.table.getSelectedRows();

				const partNo = this.searchParams.partNo;
				const params = { partNo: partNo, saveRows: saveRows };
				const { code, messageCd } = await this.saveMaster_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		//마스터 목록 더블클릭시 상세목록 조회
		async dblClickRow({ partNo, ckuPrvsCd, prvsClCd, prvsClNm, ckuWayCd, rowStatus }) {
			const param = { partNo, ckuPrvsCd, prvsClCd, prvsClNm, ckuWayCd };
			this.setCurrentMstValue_(param);
			if (rowStatus !== 'I') {
				if (partNo != '' && ckuPrvsCd != '' && prvsClCd != '') {
					// this.$sf_toggleLoading(true);
					this.getPartCkuDelList_({ partNo, ckuPrvsCd, prvsClCd, ...this.detailPagingInfo, currentPage: 1 }).finally(() =>
						this.$sf_toggleLoading(false)
					);
				} else {
					this.$sf_showMessage({
						icon: 'error',
						//title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('QWCC001095') //검사항목부터 등록해 주시기 바랍니다.
					});
					return;
				}
			} else {
				this.setDetailInit_();
			}
		},
		copyPopup() {
			this.$refs.partCkuPrvsPopup.open();
		},
		// 엑셀다운 템플릿
		downExcelTemp() {
			let params = {
				apiGubun: 'PART_CKU_MST'
			};
			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001813'), //타이틀바 값 [부품검사 항목정보 엑셀 업로드]
				apiGubun: 'PART_CKU_PRVS', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		excelRefresh() {
			this.$emit('Refresh');
		},
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'spcRslt') {
				slotProps.row.spcRslt = qmsUtils.getLimitedByteText(value, 20);
			}
		},
		deleteAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selected = this.$refs.table.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001196'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001136'), clickFn: this.deleteMaster }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deleteMaster() {
			this.$sf_toggleLoading(true);
			try {
				const delRows = this.$refs.table.getSelectedRows();

				const partNo = this.searchParams.partNo;
				const params = { partNo: partNo, delRows: delRows };
				const { code, messageCd } = await this.deleteMaster_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>
